export default __webpack_public_path__ + "static/media/13.a75b9d80.webp";